import React from 'react';
import { Link } from 'react-router-dom';

function Features() {
  return (
    <>
      <section className="page-banner bg-blue rel z-1" style={{backgroundImage: 'url(/assets/images/background/banner-bg.png)'}}>
        <div className="container">
          <div className="banner-inner">
            <h1 className="page-title wow fadeInUp delay-0-2s">CRM Features</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">CRM Features</li>
              </ol>
            </nav>
          </div>
        </div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots-two.png" alt="Shape" />
        <img className="tringle-shape slideLeftRight" src="/assets/images/shapes/white-tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/white-close.png" alt="Shape" />
        <img src="/assets/images/newsletter/circle.png" alt="shape" className="banner-circle slideUpRight" />
        <img className="dots-shape-three slideUpDown delay-1-5s" src="/assets/images/shapes/white-dots-three.png" alt="Shape" />
      </section>

      <section className="projects-details-section pt-130 rpt-100 pb-135 rpb-75">
        <div className="container">
          <div className="project-details-content">
            <div className="project-content-two wow fadeInUp delay-0-2s">
              <h2>How we're helping to grow your businesses</h2>
              <p>By organizing your customer interactions in one place, CRM software helps cut down on manual tasks. It allows all your client-facing teams including sales, marketing and customer services on new and existing customers.</p>
              <div className="mt-4">
                <Link to="/features-detail" className="theme-btn">View All 17 Detailed Features <i className="fas fa-arrow-right"></i></Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="feedback-item-two" style={{height: '950px'}}>
                <h5 className="text-center">Lead Management</h5>
                <img src="/my/LeadManagement.png" style={{height: '250px', width: '100%'}} alt="Lead Management" />
                <p className="text-justify">
                  Lead management is a process in which leads are qualified, analyzed and nurtured so that they can be converted into businesses. In the sales process, leads from multiple channels enter in the lead management system, and the sales-ready leads are converted into profit. AcuIT CRM software helps to collect all your leads in one place to track better. Our CRM software will help to track the sales leads from small and large businesses.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="feedback-item-two" style={{height: '950px'}}>
                <h5 className="text-center">Follow-up</h5>
                <img src="/my/Followup.png" style={{height: '250px', width: '100%'}} alt="Follow-up" />
                <p className="text-justify">
                  Follow up is the process of completing a task or project in a particular business and our CRM follow up feature helps you to engage with customers effectively. CRM software follow up features includes Tracking of projects/tasks, Sales streamlining and Increase your productivity by removing repetitive, time consuming tasks to measure your key activities. Streamline your customer relationship management system with leading CRM software from AcuIT. Find out how we can help you boost your business today!
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="feedback-item-two" style={{height: '950px'}}>
                <h5 className="text-center">Client Management</h5>
                <img src="/my/Clientmanagement.png" style={{height: '250px', width: '100%'}} alt="Client Management" />
                <p className="text-justify">
                  The main success of business always depends on their understanding of clients' needs. AcuIT CRM software helps client management to ensure all views of your client's requirements and their expectations. Get complete details about your clients, engage in conversations and boost your sales with our CRM software. Benefits of using client management features in CRM software includes organized information, better collaboration and increase in revenue.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="feedback-item-two" style={{height: '1120px'}}>
                <h5 className="text-center">Marketing</h5>
                <img src="/my/Marketing.png" style={{height: '250px', width: '100%'}} alt="Marketing" />
                <p className="text-justify">
                  Learn how to get your sales, service and marketing teams working together. With the growing popularity of the digitized world, customers are tending towards marketing in digital platforms. Our CRM Software associated marketing strategies like direct marketing, web marketing, email marketing, Bulk SMS, etc. AcuIT online CRM has a feature to track ROI for each and every SMS and email campaigns. These campaigns will be helpful for building strong leads and relationships with your existing customers.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="feedback-item-two" style={{height: '1120px'}}>
                <h5 className="text-center">SMS & Email Integration</h5>
                <img src="/my/smsemailintegration.png" style={{height: '250px', width: '100%'}} alt="SMS & Email Integration" />
                <p className="text-justify">
                  Businesses that use customer relationship management (CRM) software are often ahead of their competitors. AcuIT CRMs can help your marketing, customer, or sales teams manage and track prospects across the customer relationship lifecycle. Combining text messaging and email marketing within your CRM can help you do both. Our CRM software API will be integrated with the website in order to show the website leads. Consequently, all business operations such as marketing, customer engagement and billing come under one roof. Thus, AcuIT is one of the Best CRM software in Malaysia.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="feedback-item-two" style={{height: '1120px'}}>
                <h5 className="text-center">Task Management</h5>
                <img src="/my/Taskmanagement.png" style={{height: '250px', width: '100%'}} alt="Task Management" />
                <p className="text-justify">
                  Our CRM software task management feature allows you to create reminders in your customer accounts that sync with your calendar. Task management is the process of monitoring your project's tasks through their various stages from start to finish. When managing tasks, it's important to maintain records and keep the account history updated. Keep track of communication with clients from calls to emails. CRM software makes the best Task Management which includes Set Reminders, Assign Tasks, Maintain & Update Records, Email Integration, Seamless Workflows, etc., Eventually, it helps the organization to understand the employee's performance and tasks will be finished in a rapid manner.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Features;

